import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

function RequiredBox(): JSX.Element {
    const { t } = useTranslation();
    
    return (
        <Box
            ml={1}
            paddingLeft={1}
            paddingRight={1}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            style={{fontWeight:"bold",fontSize:"15px",backgroundColor: "red", color: "white",borderRadius: "5px",padding: "0 8px"}}
        >
            {t('component.requiredBox.required')}
        </Box>
    );
};

export default RequiredBox;
